import * as React from "react";
import useDocumentTitle from "hooks/useDocumentTitle";
const DocumentTitle = ({ children, title }) => {
  useDocumentTitle(`${title}`);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export default DocumentTitle;
